import React, { FC } from 'react';
import { SelectInput, useTranslate, required } from 'react-admin';
import { usePnlAccounts } from '~/hooks/pnlAccounts';
import { GlTypeLabel } from '~/components';
import { Account } from '~/types';
import { l } from '../CurrenciesList';

interface Props {
  currency: string;
}

const accountOptionText = (choice?: Account) =>
  choice ? <GlTypeLabel glType={choice.glType} text={choice.alias} /> : '';

const TradingAccountSelect: FC<Props> = (props) => {
  const { currency } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));
  const pnlAccountsQuery = usePnlAccounts({ regulatoryType: 'POOL' });

  return (
    <SelectInput
      source={`tradingAccounts.${currency}`}
      choices={pnlAccountsQuery.data?.filter(
        (item) => item.currency === currency && item.type !== 'SETTLEMENT'
      )}
      optionText={accountOptionText}
      label={`${currency} ${t('tradingAccountId')}`}
      validate={required()}
      disabled={pnlAccountsQuery.isLoading}
    />
  );
};

export default TradingAccountSelect;
